module.exports = __webpack_public_path__ + "media/images/pla/pla25-7254355844aa18b210129716e8e31d4e.jpg";